<!--
 * @Author: Jarun
 * @Date: 2021-03-25 16:06:51
 * @LastEditTime: 2021-04-06 15:35:32
 * @LastEditors: Please set LastEditors
 * @Description: PasswordInput
 * @FilePath: \box.mengw.com\src\components\PasswordInput\PasswordInput.vue
-->
<template>
    <div>
        <i class="register_input_icon_left icon_lock"></i>
        <Field
            label=""
            v-model="password"
            class="common_ring_btn"
            autocomplete="off"
            :type="type"
            :placeholder="placeholder"
            v-on:input="commitValue"
        >
            <template #button v-if="isShowEyes">
                <i
                    href="javascript:;"
                    v-if="type == 'text'"
                    v-on:click="showPassword"
                    class="register_input_icon_right icon_eye"
                ></i>
                <i
                    href="javascript:;"
                    v-else
                    v-on:click="showText"
                    class="register_input_icon_right icon_no_eye"
                ></i>
            </template>
        </Field>
    </div>
</template>

<script lang="js">
import {
  defineComponent, reactive, toRefs, onMounted,watch
} from 'vue';
import { Field, Form } from 'vant';
import router from '@/router';

export default defineComponent({
  name: 'PasswordInput',
  emits: ['password','changePassword'],
  components: {
    Field,
    Form,
  },
  props: [
    'placeholder','password','type'
  ],
  setup(props, context) {
    const state = reactive({
      password: '',
      placeholder: '',
      type: 'password',
      isShowEyes: true,
    });
    watch(()=>props.password,(newVal, oldVal)=>{
      if(props.password){
        state.password = props.password
      }
    })

    onMounted(() => {
      state.placeholder = props.placeholder;
      if(props.type){
        state.type = props.type;
        state.isShowEyes = false;
      }
    });

    const showPassword = () => {
      state.type = 'password';
    };

    const showText = () => {
      state.type = 'text';
    };

    const commitValue = (e) => {
      context.emit('changePassword', e.target.value);
    };

    return {
      showPassword,
      showText,
      commitValue,
      ...toRefs(state),
    };
  },
});
</script>

<style lang="less" scoped>
@charset "utf-8";
@import "@/assets/less/common/register.less";
</style>
